import { RealEstatePrice } from '../../../../@types/real-estate-api-types'
import { DE, formatDecimal } from '../../../../i18next/decimal'

const toNumberPrice = (value: string | number): number => {
  return typeof value === 'string' ? parseFloat(value) : value
}

export const priceToApp = (realEstatePrice: RealEstatePrice) => {
  if (
    realEstatePrice.monthlyRent !== undefined &&
    realEstatePrice.monthlyRent !== '' &&
    realEstatePrice.price !== undefined &&
    realEstatePrice.price !== ''
  ) {
    const convertedManualTotalRent = formatDecimal(Number(realEstatePrice.price).toString(), DE, 2, 2)
    return {
      price: toNumberPrice(realEstatePrice.monthlyRent),
      manualTotalRent: convertedManualTotalRent,
    }
  }
  if (realEstatePrice.monthlyRent !== undefined && realEstatePrice.monthlyRent !== '') {
    return { price: toNumberPrice(realEstatePrice.monthlyRent) }
  } else if (realEstatePrice.price !== undefined && realEstatePrice.price !== '') {
    return { price: toNumberPrice(realEstatePrice.price) }
  }
}
